import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=b8db7366&scoped=true&"
import script from "./editService.vue?vue&type=script&lang=js&"
export * from "./editService.vue?vue&type=script&lang=js&"
import style0 from "./editService.vue?vue&type=style&index=0&id=b8db7366&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8db7366",
  null
  
)

export default component.exports